import { render, staticRenderFns } from "./safetyGearReceiveStatusDetail.vue?vue&type=template&id=18452428"
import script from "./safetyGearReceiveStatusDetail.vue?vue&type=script&lang=js"
export * from "./safetyGearReceiveStatusDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18452428')) {
      api.createRecord('18452428', component.options)
    } else {
      api.reload('18452428', component.options)
    }
    module.hot.accept("./safetyGearReceiveStatusDetail.vue?vue&type=template&id=18452428", function () {
      api.rerender('18452428', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/sas/safetyGearReceiveStatusDetail.vue"
export default component.exports